import React, { Suspense } from 'react';
import { Route, Redirect } from 'react-router-dom';
import auth from '../actions/auth'
import Header from '../components/Header';

export const PrivateRoute = ({
  isAuthenticated,
  component: Component,
  ...rest
}) => {
return (
    <Route {...rest} render={props => {
      if (auth.isAuthenticated())  
        return (
            <div>
        <Header />
        {/* Some pages load their code on demand; keep the header up while they do. */}
        <Suspense fallback={<div className="page"><div className="loading-line">Loading…</div></div>}>
          <Component {...props} />
        </Suspense>
        </div>
        )
      else {
       return <Redirect to="/" />
      }
         
    } 
    }
    />
  );
    }

// const mapStateToProps = (state) => ({
//   isAuthenticated: !!state.auth.username
// });

export default PrivateRoute;
